var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ad)?_c('div',{staticClass:"home-content-ad",style:(_vm.wrapperStyle)},[_c('advertisement-placement',{attrs:{"placement":"home_content"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }